import axios from '../api/index.js';

//查询通知公告列表
export let getPolicyQuery = (params) => {
    return axios.post(`/client/policy/list`,params);
};

//查询通知公告介绍详情
export let getPolicyContent = (params) => {
    return axios.get(`/client/policy/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/policy.js